export const schema = ($http: HttpApi) => ({
  update: () => $http.$patch('/builder/schema'),
});
